var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    {
      class:
        !_vm.stretchL || !_vm.$vuetify.breakpoint.lgAndUp
          ? "mrc_main_slide_conteiner"
          : "mrc_main_conteiner",
    },
    [
      _c(
        "v-container",
        {
          staticClass:
            "\n      scroll_content_y\n      pb-0\n      d-flex\n      flex-column\n      main-content\n      scroll_content_x_no\n      align-center\n    ",
          style: {
            height: _vm.$vuetify.breakpoint.height - 56 + "px",
            position: "relative",
            paddingRight:
              _vm.$route.path === "/dashboard" &&
              _vm.$vuetify.breakpoint.name != "xs" &&
              _vm.stretchR &&
              _vm.$vuetify.breakpoint.lgAndUp
                ? "352px"
                : "12px",
          },
          attrs: { fluid: "" },
        },
        [
          !_vm.hidden
            ? _c(
                "v-container",
                {
                  staticClass:
                    "scroll_content_y no_scroll d-flex flex-column justify-start",
                  class: _vm.LRPadding + " pb-0",
                  style: {
                    minHeight: _vm.$vuetify.breakpoint.height - 56 - 52 + "px",
                    maxWidth: _vm.fillWidth
                      ? "100%"
                      : _vm.isSpecial
                      ? "2000px"
                      : "1600px",
                  },
                  attrs: { fluid: "" },
                },
                [
                  Number(_vm.SYSTEM_STATUS) == 3 && !_vm.isGod
                    ? [_c("PermissionPage")]
                    : _vm._e(),
                  Number(_vm.SYSTEM_STATUS) == 2
                    ? [_c("SystemErrorPage")]
                    : _vm._e(),
                  Number(_vm.SYSTEM_STATUS) == 1
                    ? [_c("NetErrorPage")]
                    : _vm._e(),
                  Number(_vm.SYSTEM_STATUS) == 0 || _vm.isGod
                    ? [
                        _c(
                          "keep-alive",
                          [
                            _vm.$route.meta.keepAlive
                              ? _c("router-view")
                              : _vm._e(),
                          ],
                          1
                        ),
                        !_vm.$route.meta.keepAlive
                          ? _c("router-view")
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm.$route.path === "/dashboard" && _vm.$vuetify.breakpoint.lgAndUp
            ? _c(
                "v-sheet",
                {
                  staticClass: "close_triger d-flex align-center rounded-l-lg",
                  style: {
                    right:
                      _vm.stretchR && _vm.$vuetify.breakpoint.lgAndUp
                        ? "334px"
                        : "-0px",
                    top: Number(_vm.scrollTopofMain) + 60 + "px",

                    zIndex: 999,
                  },
                  attrs: { width: "20", height: "40" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("slideRightChange", !_vm.stretchR)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons-round ma-auto" }, [
                    _vm._v(
                      _vm._s(!_vm.stretchR ? "arrow_left" : "arrow_right")
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _c("v-spacer"),
          _c("Footer", {
            attrs: {
              center: _vm.$route.path == "/dashboard",
              maxWidth: _vm.fillWidth
                ? "100%"
                : _vm.isSpecial
                ? "2000px"
                : "1600px",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }